export default __webpack_public_path__ + "static/media/camp412-1.ab750a82.jpg";